import store from './index'
import AppointmentGuruBackend from './backends/appointmentguru'
import MetaDataGuruBackend from './backends/metadataguru'
import InvoiceGuruBackend from './backends/invoiceguru'
import AuthenticationGuruBackend from './backends/authenticationguru'
import MedicalAidGuruBackend from './backends/medicalaidguru'
import CommunicationGuruBackend from './backends/communicationguru'
import CodeGuruBackend from './backends/codeguru'
import SubscriptionGuruBackend from './backends/subscriptionguru'

/* eslint-disable new-cap */
export default {
  store,
  install (Vue, options) {
    Vue.prototype.$env = process.env
    Vue.prototype.$store = store
    Vue.prototype.$appointmentguru = new AppointmentGuruBackend('appointmentguru', store)
    Vue.prototype.$metadataguru = new MetaDataGuruBackend('metadataguru', store)
    Vue.prototype.$invoiceguru = new InvoiceGuruBackend('invoiceguru', store)
    Vue.prototype.$authenticationguru = new AuthenticationGuruBackend('authenticationguru', store)
    Vue.prototype.$medicalaidguru = new MedicalAidGuruBackend('medicalaidguru', store)
    Vue.prototype.$communicationguru = new CommunicationGuruBackend('communicationguru', store)
    Vue.prototype.$codeguru = new CodeGuruBackend('codeguru', store)
    Vue.prototype.$subscriptionguru = new SubscriptionGuruBackend('subscriptionguru', store)
  }
}



// WEBPACK FOOTER //
// ./src/store/plugin.js